import { generatePublicId } from 'flow/store/engine/utils';
import type { Snapshot } from 'flow/store/redux/types';

export function createSnapshot<T>(args: { data: T }): Snapshot<T> {
  return {
    snapshotId: generatePublicId('snapshot'),
    data: args.data,
  };
}

export function trimSubsequentSnapshots(
  snapshots: Snapshot<unknown>[],
  snapshotId: Snapshot<unknown>['snapshotId'],
) {
  const snapshotIndex = snapshots.findIndex(snapshot => snapshot.snapshotId === snapshotId);
  return snapshotIndex === -1
    ? snapshots.slice()
    : snapshots.slice(0, snapshotIndex + 1);
}
